import { Controller } from "@hotwired/stimulus";

// Clears form field values within this controller's element when the clear action is triggered.
// Usage:
// <div data-controller="clear-fields">
//   ... form fields ...
//   <button type="button" data-action="click->clear-fields#clear">Clear</button>
// </div>
//
// Optional: add data-clear-fields-ignore="true" to any element you want to skip.
// Dispatches a `fields:cleared` CustomEvent on this.element after clearing.
export default class extends Controller {
  clear(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    console.log("ClearFieldsController: clearing fields");

    const selectors = ["input", "textarea", "select"].join(",");

    const fields = this.element.querySelectorAll(selectors);

    fields.forEach((field) => {
      if (field.disabled) return;
      if (field.dataset.clearFieldsIgnore === "true") return;

      switch (field.type) {
        case "checkbox":
        case "radio":
          if (field.checked) {
            field.click(); // use click to ensure any listeners are triggered
          }
          break;
        case "file":
          field.value = ""; // can't programmatically clear files in all browsers, but setting empty string works when not yet uploaded
          break;
        default:
          // For selects (single/multiple) and other inputs
          if (field.tagName === "SELECT") {
            field.selectedIndex = -1; // deselect all
            // If Semantic UI dropdown, also clear the hidden input value
            if (
              field.hasAttribute("data-controller") &&
              field.getAttribute("data-controller").includes("dropdown")
            ) {
              $(field).dropdown("clear");
            }
            if (field.multiple) {
              Array.from(field.options).forEach((o) => (o.selected = false));
            }
          } else {
            field.value = "";
          }
      }

      // Trigger input & change events so any listeners update.
      field.dispatchEvent(new Event("input", { bubbles: true }));
      field.dispatchEvent(new Event("change", { bubbles: true }));
    });

    // Also clear any contenteditable descendants unless ignored
    this.element
      .querySelectorAll('[contenteditable=""], [contenteditable="true"]')
      .forEach((node) => {
        if (node.dataset.clearFieldsIgnore === "true") return;
        node.innerHTML = "";
      });

    const clearedEvent = new CustomEvent("fields:cleared", { bubbles: true });
    this.element.dispatchEvent(clearedEvent);
  }
}
